$(document).ready(function() {
	setTimeout(function() {
		$('.swym-button-bar.swym-wishlist-button-bar.swym-inject').insertBefore('form.product-single__form button.btn.btn--full.add-to-cart.add-to-cart--secondary');
	}, 1500);
	// on load discount data higlight
	var selectedValonload = $('select.custom_select_box option:selected').val();
	$(`tr.slabrow[data-id=${selectedValonload}]`).addClass('focus');
	$('.quantity_box input.js-qty__num').val(selectedValonload);


	// on click discount data higlight
	$('body').on('change', 'select.custom_select_box', function() {
		;
		var productLink = $('p.h2.product-single__title').attr('product-url');
		//alert(productLink)
		var selectedVal = parseInt($(this).find('option:selected').val());
		$('.quantity_box input.js-qty__num').val('');
		$('.quantity_box input.js-qty__num').val(selectedVal);
		var actualPrice = $('.product-block.product-block--price span.product__price').attr('data-money');
		$('tr.slabrow').removeClass('focus');
		$(`tr.slabrow[data-id=${selectedVal}]`).addClass('focus');
		// if the price is 150 or more than 150
        console.log(selectedVal)
		if(selectedVal >= 19) {
			if ($('html').hasClass('modal-open')) {
				window.location.href = productLink;
			} else {
				$('html, body').animate({
					scrollTop: $(".product-block.product-block--tab.contact_form").offset().top - 70
				}, 2000);
				if ($('.product-block--tab.contact_form button.label.collapsible-trigger').hasClass('is-open')) {} else {
					$('.product-block--tab.contact_form button.label.collapsible-trigger.collapsible-trigger-btn').trigger('click');
				}
			}
		}
	})
// conatct form page number selected 
    $('body').on('change','select.input-full.custom_country_slecte_bocx',function () {
  var cntryName = $(this).find('option:selected').text();
  $('.custom_country_code select option').removeAttr('selected','selected');
    $(`.custom_country_code select option[data-country="${cntryName}"]`).attr('selected','selected');
})
// custom message limit code
$('body').on('click','.btn.custom_new_btn',function (e) {
  e.preventDefault();

   var MessageVal = $('.contact-form textarea').val();
    console.log(MessageVal.length);
    if(MessageVal.length < 100){
$('p.custom_error_paragraph').show();
    }else{
$('p.custom_error_paragraph').hide();
  $('button.btn.original_button_btn').trigger('click');
    }
})

//socil-icon
$(".social-open-menu").click(function() {
  $(".social-itens").toggleClass("open");
  $(".social-itens").toggleClass("hidden");
});
// conatct form poup start

$('body').on('click','.custom_contact_form_to_get_more',function () {
  $('body').addClass('is-contact-active');
    $('.custom_propup_contact_form').show();
})
  // pdp contact form hide 
  $('body').on('click','svg.custom_products_form_cloe_icon',function () {
  $('body').removeClass('is-contact-active');
    $('.custom_propup_contact_form').hide();
})
   $(document).on('click', function (event) {
        var $target = $(event.target);
        if (!$target.closest('.custom_propup_contact_form').length && 
            !$target.closest('.custom_contact_form_to_get_more').length) {
            $('body').removeClass('is-contact-active');
            $('.custom_propup_contact_form').hide();
        }
    });
  // onload qty val

$('.product-block.quantity_box .js-qty__num').val('1');
  // chnage the  Rs to rupee start
 
    $('.product__price').each(function() {                         
         var priceText = $(this).text();
         var updatedPriceText = priceText.replace('Rs.', '₹');
         $(this).text(updatedPriceText);
    });
   setTimeout(function () {
   $('span.grid-product__price--original').each(function () {
    var priceText1 = $(this).text();
         var updatedPriceText1 = priceText1.replace('Rs.', '₹');
         $(this).text(updatedPriceText1); 
});
     $('span.sale-price').each(function () {
    var priceText1 = $(this).text();
         var updatedPriceText1 = priceText1.replace('Rs.', '₹');
         $(this).text(updatedPriceText1); 
});
     $('.cart__price ,.cart__discount,div[data-subtotal],.cart__savings').each(function () {
    var priceText = $(this).text();
         var updatedPriceText = priceText.replace('Rs.', '₹');
         $(this).text(updatedPriceText); 
});
     $('.grid-product__price span').each(function () {
    var priceText = $(this).text();
         var updatedPriceText = priceText.replace('Rs.', '₹');
         $(this).text(updatedPriceText); 
});
     }, 2500);
    // chnage the  Rs to rupee end
});
//announcement bar class
    $(window).on('scroll', function() {
        if ($(this).scrollTop() > 299) {
            $('.announcement').addClass('announcement-sticky announcement-trans');
        } else {
             $('.announcement').removeClass('announcement-sticky announcement-trans');
        }
    });

// quantity reset on variant change

document.addEventListener("DOMContentLoaded", function () {
    const variantSelect = document.querySelector("select[name='id']"); // Dropdown selector
    const quantityInput = document.querySelector("input[name='quantity']");

    if (variantSelect && quantityInput) {
        variantSelect.addEventListener("change", function () {
            quantityInput.value = 1; // Reset quantity to 1
        });
    }
});
